module.exports = __webpack_public_path__ + "img/juntos_white_600px.fb054d19.png";